function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 25,
  cy: 25,
  r: 25,
  fill: "#FC4C02"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.6,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.5625 27.5L30.375 41.5625L37.875 27.5H33.1875L30.375 32.8125L27.25 27.5H22.5625Z",
  fill: "white"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.5 7.8125L33.1875 27.5H13.5L23.5 7.8125ZM23.5 19.6875L27.25 27.5H19.4375L23.5 19.6875Z",
  fill: "white"
});

var SvgSourceStrava = function SvgSourceStrava(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSourceStrava, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/source_strava.6c8b8d82.svg";
export { ForwardRef as ReactComponent };